import { AxiosRepo } from '@/helpers/interceptorsSetup';
import { CONSTANTS } from '@/constants/guide';
import { deleteCookie, getUserFromLS } from '@/helpers/userHelper';

const axiosInstance = AxiosRepo.getInstance();

export const actions = {
  removeItemFromCart({ dispatch, commit, state }, itemId) {
    commit('startLoading');
    return axiosInstance
      .post(`${CONSTANTS.APP.BASE_URL}/Api/v1_json/wp`, {
        ItemId: itemId,
        QuoteId: state.quoteId,
        T: Date.now(),
        Method: 'RemoveItemFromCart',
        CustomerId: getUserFromLS().identity.id,
        useCookieAuth: true
      })
      .then(response => {
        deleteCookie('client_id');
        commit('removeFromCart', itemId);
        // dispatch('getCartContent');
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        console.log(error);
        return Promise.resolve({ success: false, error: error });
      });
  },
  getCartContent({ dispatch, commit, state }, clientId) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/getCartContent`, {
        clientId: clientId,
        T: Date.now()
      })
      .then(response => {
        commit('putCartContent', response);
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  updateCartItem({ dispatch, commit, state }, payload) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/updateQuoteItem`, {
        T: Date.now(),
        ItemId: payload.itemId,
        newQty: payload.newQty
      })
      .then(response => {
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  updatePackage({ dispatch, commit, state }, payload) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/updatePackage`, {
        T: Date.now(),
        ItemId: payload.itemId,
        Options: payload.options
      })
      .then(response => {
        commit('putCartContent', response);
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  clearCart({ dispatch, commit, state }) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/clearCart`, { T: Date.now() })
      .then(response => {
        commit('putCartContent', response);
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  clearOtherClientItems({ dispatch, commit, state }, data) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/clearOtherClientItems`, {
        clientId: data.id,
        isVet: data.isVet,
        T: Date.now()
      })
      .then(response => {
        commit('putCartContent', response);
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  getOrderCheckoutInfo({ dispatch, commit, state }, orderId) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/getOrderCheckoutInfo`, {
        orderId: orderId,
        T: Date.now()
      })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  getProductsSuggestions({ dispatch, commit, state }, payload) {
    commit('startLoading');

    return axiosInstance
      .get(`/ivs/CheckOut/getProductsSuggestions`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.log(error);
      });
  },
  addProductToCart({ dispatch, commit, state }, payload) {
    commit('startLoading');

    return axiosInstance
      .post(`/ivs/CheckOut/addProductToCart`, {
        productId: payload.productId,
        clientId: payload.clientId,
        T: Date.now()
      })
      .then(response => {
        commit('putCartContent', response);
        return Promise.resolve({ success: true });
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  }
};
